<template>
    <div class="project-selection">
        <app-header :isDashboard="false"  :isProject="false" :projectTitle="projectTitle" :username="username"></app-header>

        <div class="container">
            <div class="row">
                <div class="col-12 text-center">
                    <img src="../assets/img/ecdc-logo.svg" alt="ecdc-logo" class="img-fluid logo" />
                </div>
            </div>

            <div class="row">
                <div class=col-12>
                    <div class="title">
                        Projects
                    </div>
                </div>
            </div>

            <div class="row row-cols-md-4 row-cols-2 justify-content-center">
                <div class="col mb-4" v-for="project in projects" v-bind:key="project.id" @click="setProject(project)">
                    <div class="card selection-card h-100">
                        {{ project.name }}
                    </div>
                </div>
            </div>
        </div>
        <app-loader v-show="isLoading"></app-loader>
    </div>
</template>

<script>
import Header from "./Header.vue";
import { getProjects } from '../api/index'
import { setProj, getAuth } from '../helpers/index'
import AuthMiddleware from './mixin/AuthMiddleware'
import Loader from './Loader.vue'

export default {
    mixins: [AuthMiddleware],
    components: {
        appHeader: Header,
        appLoader: Loader
    },
    data() {
        return {
            projects: [],   
            projectTitle: "",
            username: "",
            isLoading: true
        }
    },
    async mounted() {
        this.username = getAuth().name;
        await this.getData();

        this.isLoading = false;
    },
    methods: {
        async getData() {

            try {            
                const result = await getProjects();
                this.projects = result.data.data.result;
            }
            catch(err) {
                alert(err.response.data.message);
            }
        },
        setProject(data) {

            setProj(data);
            this.$router.push({ name: "dashboard" })
        }
    }
}
</script>

<style scoped>
.project-selection .logo {
    margin-bottom: 60px;
}

.project-selection .title {
    margin-bottom: 40px;
}

.project-selection .card {
    padding-top: 40px;
    padding-bottom: 40px;
}
</style>